import { ItemWithLabel as ItemWithLabelBase } from "clearline-common";

/** @deprecated Use import from `clearline-common` */
export interface ItemWithLabel<T> extends ItemWithLabelBase<T> {}
